export interface AuthUrlInterface {
  redirectUrl: string
}

export enum IntegrationUseCaseEnum {
  Spreadsheets = 'spreadsheets',
  Calendar = 'calendar',
}

export interface IntegrationInterface extends IntegrationBaseInterface {
  useCases: IntegrationUseCaseEnum[]
  googleUserName: string
  createdAt: string
  updatedAt: string
  disconnectedAt: string | null
}

interface IntegrationBaseInterface {
  id: string
  googleUserEmail: string
}

export enum CalendarAccessRoleEnum {
  FreeBusyReader = 'FreeBusyReader',
  Reader = 'Reader',
  Writer = 'Writer',
  Owner = 'Owner',
}

export interface CalendarInterface {
  id: string
  name: string
  isPrimary: boolean
  backgroundColor: string
  accessRole: CalendarAccessRoleEnum
  integration: IntegrationBaseInterface
  isUsedForSync: boolean
  isUsedForCheck: boolean
}
